import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface HeaderChatButtonProps {
  phoneNumber?: string;
  message?: string;
}

const HeaderChatButton = ({
  phoneNumber = '27625819719',
  message = 'Hi LUMZA! I need customer support.'
}: HeaderChatButtonProps) => {
  const getWhatsAppUrl = () => {
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  };

  const handleClick = () => {
    window.open(getWhatsAppUrl(), '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={handleClick}
      className="flex items-center p-2 touch-target text-[#25D366] hover:text-[#128C7E] hover:bg-[#25D366]/10"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-4 w-4" />
    </Button>
  );
};

export default HeaderChatButton;
